import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material';

const styles = makeStyles(() => ({
	toolbar: {
		display: 'flex',
		justifyContent: 'space-between',
		padding: '0px 0px 0px 16px',
		backgroundColor: '#fff',
	},
	boxContainer: {
		flex: 1,
		display: 'flex',
		justifyContent: 'flex-end',
	},
	avatarText: {
		color: '#000',
	},
	user: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	avatar: {
		cursor: 'pointer',
		height: 40,
		width: 40,
		marginRight: useTheme().spacing(2),
		marginLeft: useTheme().spacing(1.3),
	},
	customButton: {
		backgroundColor: 'rgb(211, 47, 47)',
	},
}));

export default styles;
